import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-793daf4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("点击查看配置")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("成交确认")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("退订")
const _hoisted_4 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_el_table, {
        data: _ctx.orderState.tableData,
        stripe: "",
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "order_no",
            label: "订单号"
          }),
          _createVNode(_component_el_table_column, { label: "用户来源" }, {
            default: _withCtx((scope) => [
              _createElementVNode("div", null, _toDisplayString(scope.row.user?.source_origin), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "created_at",
            label: "创建订单时间"
          }),
          _createVNode(_component_el_table_column, {
            prop: "address",
            label: "配置详情"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                onClick: ($event: any) => (_ctx.handleShowCarInfoDialog(scope.row)),
                type: "text"
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { label: "销售人员" }, {
            default: _withCtx((scope) => [
              _createElementVNode("div", null, _toDisplayString(scope.row.seller_name), 1),
              _createElementVNode("div", null, _toDisplayString(scope.row.seller_mobile_number), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "buyer_name",
            label: "购车人信息"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("div", null, _toDisplayString(scope.row.buyer_name), 1),
              _createElementVNode("div", null, _toDisplayString(scope.row.buyer_mobile_number), 1),
              _createElementVNode("div", null, _toDisplayString(scope.row.buyer_id_card), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "payment_method",
            label: "购车方式"
          }),
          _createVNode(_component_el_table_column, {
            prop: "wx_transaction_id",
            label: "支付订单号"
          }),
          _createVNode(_component_el_table_column, {
            prop: "car_info.deposit_text",
            label: "支付定金金额(元)"
          }),
          _createVNode(_component_el_table_column, {
            prop: "expect_deliver_at",
            label: "预计交车时间"
          }),
          _createVNode(_component_el_table_column, {
            prop: "status_name",
            label: "订单状态"
          }),
          _createVNode(_component_el_table_column, { label: "管理" }, {
            default: _withCtx((scope) => [
              ([_ctx.OrderStatus.PAID, _ctx.OrderStatus.DEAL].includes(scope.row.status))
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    onClick: ($event: any) => (_ctx.handleShowConfirmDialog(scope.row)),
                    type: "text"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              ([_ctx.OrderStatus.PAID].includes(scope.row.status))
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    type: "text",
                    onClick: ($event: any) => (_ctx.handleCloseOrder(scope.row))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (![_ctx.OrderStatus.PAID, _ctx.OrderStatus.DEAL].includes(scope.row.status))
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, "--"))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_el_pagination, {
        style: {"padding":"20px 0","text-align":"right"},
        background: "",
        layout: "total, prev, pager, next",
        total: _ctx.orderState.totalCount,
        "current-page": _ctx.orderState.searchOptions.page,
        "page-size": _ctx.orderState.searchOptions.count,
        onCurrentChange: _ctx.handlePageChange
      }, null, 8, ["total", "current-page", "page-size", "onCurrentChange"])
    ])
  ]))
}